import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.063 4.07272C8.19415 4.52251 6 7.00475 6 10v3.343c0 1.061-.421 2.078-1.172 2.829L3 18v1h18v-1l-1.828-1.828C18.421 15.421 18 14.404 18 13.343v-3.091c0-3.00836-2.1222-5.66386-5-6.16631V2.969c0-.535-.434-.969-.969-.969-.535 0-.968.434-.968.969v1.10372zM12 22c-1.105 0-2-.895-2-2h4c0 1.105-.895 2-2 2zm0-16l.125.002c2.137.064 3.875 1.97 3.875 4.25v3.091c0 1.34.436 2.613 1.242 3.657H6.758C7.564 15.956 8 14.683 8 13.343V10c0-2.206 1.794-4 4-4z",
    fill: "currentColor"
  }));
});